import React, { ReactNode, useEffect } from 'react'
import { hermesInterceptor } from './hermes-api/interceptor'
import { type ApiErrorHandler, type ErrorHandlers } from './shared/interceptors/interceptor-manager'
import { setActiveTenant } from './shared/setActiveTenant'
import { setActiveUser } from './shared/setActiveUser'
import { Region } from './shared/utils/region'
import { HermesSdkContext } from './hermes-sdk-context'

export type { ApiErrorHandler, ErrorHandlers }

export const HermesSdkProvider: React.FC<{
  children: ReactNode
  defaultErrorHandler?: ApiErrorHandler
  errorHandlers?: ErrorHandlers
  user?: {
    id: number
    accessToken: string
  }
  tenant: Region
}> = ({ children, errorHandlers = {}, defaultErrorHandler, user, tenant }) => {
  useEffect(() => {
    hermesInterceptor.setErrorHandlers(errorHandlers, defaultErrorHandler)
  }, [errorHandlers, defaultErrorHandler])

  useEffect(() => {
    if (user?.accessToken) {
      setActiveUser({
        id: user.id,
        token: user.accessToken
      })
    }
  }, [user?.accessToken])

  useEffect(() => {
    if (tenant) {
      setActiveTenant(tenant)
    }
  }, [tenant])

  return (
    <HermesSdkContext.Provider value={{ tenant, accessToken: user?.accessToken }}>{children}</HermesSdkContext.Provider>
  )
}
